import * as React from "react";
import {
  Checkbox,
  Dropdown,
  Field,
  makeStyles,
  Option,
  shorthands,
  useId,
} from "@fluentui/react-components";
import type { CheckboxProps, DropdownProps } from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import ASCDropdown from "../DropDown";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";

type ComponentProps = {
  [x: string]: any;
};
const useStyles = makeStyles({
  // fixed_dropdown_button: {
  //   minWidth: "150px !important",
  //   maxWidth: "300px !important",
  //   maxHeight: "60px !important",
  // },
});
export const DropdownDatepicker = (props: any) => {
  const style = props;
  const dispatch: AppDispatch = useDispatch();
  const styles = useStyles();

  return (
    <Dropdown
      // className={styles.fixed_dropdown_button}
      placeholder={
        props.optionDateValue !== "" ? props.optionDateValue : "Select the Date"
      }
      style={style}
      onClick={() => {
        dispatch(
          setDialogModalOptions({
            open: true,
            date_filter: true,
            dateSelection: props.dateSelection,
            dateLabel: props.dateLabel,
            optionDateValue: props.optionDateValue,
            optionDate: props.optionDate,
          }),
        );
      }}
    ></Dropdown>
  );
};
